import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_MultiStationVisitorTypeMaintenance } from "../shared/data.service";
import { VisitorTypeModifyRequest } from "../shared/VisitorTypeModifyRequest";

@Component({
	selector: "app-ms-add-visitor-type",
	templateUrl: "./ms-add-visitor-type.component.html",
	styleUrls: ["./ms-add-visitor-type.component.css"],
})
export class MsAddVisitorTypeComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private visitorService: DataService_MultiStationVisitorTypeMaintenance
	) {}

	ngOnInit(): void {}

	/////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////
	VisitorTypeDesc: string = "";
	errorMessage: string = "";
	Processing: boolean = false;
	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		if (this.VisitorTypeDesc == undefined || this.VisitorTypeDesc.trim().length == 0) {
			this.errorMessage = "Enter name of the visitor type";
			return;
		}

		//
		// Check Name Already Used
		//
		this.Processing = true;

		var parms: VisitorTypeModifyRequest = {
			VisitorTypeID: -1, //Adding new
			VisitorTypeDesc: this.VisitorTypeDesc,
		};

		var result = this.visitorService.VisitorTypeInUse(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.onFinishAdd(parms);
				} else {
					this.Processing = false;

					//Fail Dialog
					this.confirmationService.confirm({
						key: "confirmadd",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the visitor type: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onFinishAdd(parms: VisitorTypeModifyRequest) {
		var result = this.visitorService.VisitorTypeInsert(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Visitor Type was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the visitor type: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////
	IsLoading() {
		return this.Processing == true;
	}
	/////////////////////////////////////////////////////////
}
